/** Один cache namespace для страницы и service worker. */
export const MEDIA_CACHE_NAME = 'media-v1'

/**
 * Privacy-cleanup не полагается на controller: на первом load, после update
 * и в Safari зарегистрированный SW может ещё не контролировать страницу.
 */
export async function clearMediaCacheStorage(): Promise<void> {
  navigator.serviceWorker?.controller?.postMessage({ type: 'MEDIA_CLEAR' })
  if ('caches' in globalThis) await globalThis.caches.delete(MEDIA_CACHE_NAME)
}
